module.exports = __webpack_public_path__ + "static/media/Necropolis.479871aa.jpg";